import { render, staticRenderFns } from "./Slideshow.vue?vue&type=template&id=59966a94&lang=pug&"
import script from "./Slideshow.vue?vue&type=script&lang=js&"
export * from "./Slideshow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59966a94')) {
      api.createRecord('59966a94', component.options)
    } else {
      api.reload('59966a94', component.options)
    }
    module.hot.accept("./Slideshow.vue?vue&type=template&id=59966a94&lang=pug&", function () {
      api.rerender('59966a94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/Slideshow.vue"
export default component.exports